import { Box, Button, Divider, Typography } from '@wishket/design-system';
import Image from 'next/image';
import { twJoin } from 'tailwind-merge';

import { TrendingAuthorCardProps } from '../types';

import { AuthorSubscriptionButton, Link } from '@/shared/Components';
import { PATH } from '@/shared/constants';
import { Avatar } from '@/features/NewLanding';

const AuthorListCard = ({
  id,
  name,
  imageUrl,
  description,
  isSubscribed,
  urlIdentifier,
  contents,
}: TrendingAuthorCardProps) => {
  const authorPageUrl = `${PATH.HOME}/@${urlIdentifier}`;

  return (
    <Box
      className={twJoin(
        'flex w-[280px] flex-col rounded-2xl bg-w-white',
        'desktop:w-[360px] desktop:duration-200 desktop:ease-in desktop:hover:-translate-y-[5%]'
      )}
      data-testid="landing-author-card"
    >
      <Box
        className={twJoin(
          'flex items-center gap-4 p-5',
          'desktop:gap-5 desktop:p-6'
        )}
      >
        <Avatar src={imageUrl} size="sm" variant="normal" />
        <Box className="flex min-w-[93px] flex-1 flex-col">
          <Link
            href={authorPageUrl}
            className="truncate font-medium text-w-gray-900"
            data-testid="trending-author-card-name-link"
          >
            <span className="typo-body1 tablet:typo-subTitle2">{name}</span>
          </Link>
          <Typography variant="body2" className="truncate text-w-gray-700">
            {description}
          </Typography>
        </Box>
        <AuthorSubscriptionButton authorId={id} />
      </Box>
      <Divider />
      <Box
        className={twJoin(
          'flex flex-1 flex-col gap-5 p-5',
          'desktop:gap-6 desktop:p-6'
        )}
      >
        <Box className="flex flex-1 flex-col">
          <Box
            className={twJoin('flex flex-1 flex-col gap-5', 'desktop:gap-4')}
          >
            {contents.map((content, index) => (
              <Link
                href={`${PATH.DETAIL}/${content.id}`}
                key={index}
                className="group flex gap-5"
                data-testid="trending-author-card-content"
              >
                <Box className="min-w-[153px] flex-1 py-[7.5px]">
                  <Typography
                    variant="body1"
                    className="line-clamp-2 font-medium text-w-gray-900 group-hover:text-w-gray-600"
                    data-testid="author-content-title"
                  >
                    {content.title}
                  </Typography>
                </Box>
                <Image
                  src={content.imageUrl}
                  alt={content.title}
                  width={67}
                  height={67}
                  className="size-[67px] rounded-xl border border-w-gray-200"
                />
              </Link>
            ))}
          </Box>
        </Box>
        <Link href={authorPageUrl}>
          <Button
            size="md"
            variant="outlined"
            className="w-full"
            data-testid="author-more"
          >
            더 보기
          </Button>
        </Link>
      </Box>
    </Box>
  );
};

export default AuthorListCard;
